import React from 'react';
import { Text } from '@components/atoms/text/Text';

export const defaultMessage = firstName => {
  return {
    subheader: 'Info',
    title: 'Your Autodesk SSO is connected',
    id: 'default',
    type: 'warning',
    content: (
      <>
        <Text
          css={{
            marginBottom: '$16',
          }}
        >
          {`Hello ${firstName},`}
        </Text>

        <Text
          as="p"
          css={{
            marginBottom: '$16',
          }}
        >
          We’re introducing <strong>Single Sign-On (SSO)</strong> to AREA to
          simplify login and make your Autodesk experience more seamless. This
          means you'll have just one login for all things Autodesk, including
          AREA.
        </Text>
        <Text>
          No action is required – you're all set, we’ve{' '}
          <strong>automatically linked your account</strong> with Autodesk's
          Single Sign-On (SSO). From now on, you can use your Autodesk
          credentials to sign in seamlessly.
        </Text>
      </>
    ),
    actions: ['doLater'],
  };
};

export const notMergedMessage = firstName => {
  return {
    subheader: 'Action Required',
    title: 'Merge your account with Autodesk SSO',
    id: 'notMerged',
    type: 'warning',
    content: (
      <>
        <Text
          css={{
            marginBottom: '$16',
          }}
        >
          {`Hello ${firstName},`}
        </Text>

        <Text
          css={{
            marginBottom: '$16',
          }}
        >
          We’re introducing <strong>Single Sign-On (SSO)</strong> to AREA to
          simplify login and make your Autodesk experience more seamless. This
          means that you’ll have just one login for all things Autodesk,
          including AREA.
        </Text>
      </>
    ),
    actions: ['doLater', 'signin'],
  };
};

export const successMessage = () => {
  return {
    subheader: 'Merge Complete',
    title: 'You’re all set!',
    id: 'success',
    type: 'success',
    content: (
      <>
        <Text
          as="p"
          css={{
            marginBottom: '$8',
          }}
        >
          Your account has been successfully merged with
          <strong> Autodesk's Single Sign-On (SSO)</strong>. You can now log in
          using your Autodesk SSO credentials for a smoother experience.
        </Text>
        <Text>
          Thanks for being part of our community. We'll have more news soon
          about further AREA improvements in the works.
        </Text>
      </>
    ),
    actions: [],
  };
};

export const confirmDifferentEmailsMessage = (current_email, adsk_email) => {
  return {
    subheader: 'Warning',
    title: 'Different emails detected',
    id: 'confirmDifferentEmails',
    type: 'warning',
    content: (
      <>
        <Text
          as="p"
          css={{
            marginBottom: '$8',
          }}
        >
          We noticed that the email associated with your Autodesk account
          doesn't match your current account email.
        </Text>
        <Text
          as="p"
          css={{
            marginBottom: '$8',
          }}
        >
          <ul>
            <li>
              <strong>Your current email:</strong> {current_email}
            </li>
            <li>
              <strong>Autodesk SSO email:</strong> {adsk_email}
            </li>
          </ul>
        </Text>

        <Text>Don’t worry! You can still merge your accounts.</Text>
        <Text>
          After merging, you’ll use your <strong>Autodesk SSO email</strong> to
          log in moving forward.
        </Text>
      </>
    ),
    actions: ['cancel', 'confirm'],
  };
};

export const errorAlreadyMergedMessage = {
  subheader: 'Error',
  title: 'Accounts not merged',
  id: 'error',
  type: 'error',
  content: <Text>{`Something went wrong, please try again`}</Text>,
  actions: ['doLater', 'signin'],
};

export const errorMessage = {
  subheader: 'Error',
  title: 'Accounts not merged',
  id: 'error',
  type: 'error',
  content: (
    <>
      <Text
        as="p"
        css={{
          marginBottom: '$8',
        }}
      >
        We encountered an issue while attempting to merge your accounts. The
        email address you are trying to merge is already associated with a
        different AREA account.
      </Text>
      <Text
        as="p"
        css={{
          marginBottom: '$8',
        }}
      >
        Please choose one of the following options to proceed:
      </Text>
      <ol>
        <li>
          <Text
            as="p"
            css={{
              marginBottom: '$8',
            }}
          >
            <strong>Log in</strong> using the associated Autodesk account
          </Text>
        </li>
        <li>
          <Text
            as="p"
            css={{
              marginBottom: '$8',
            }}
          >
            <strong>Log out</strong> from Autodesk and sign in with a different
            account or create a new one using the same email address used in
            this account
          </Text>
        </li>
      </ol>

      <Text
        as="p"
        css={{
          marginBottom: '$8',
        }}
      >
        If you need further assistance, feel free to{' '}
        <a
          alt="Help"
          href="https://forums.autodesk.com/t5/report-a-website-issue/ct-p/report-a-website-issue"
          target="_blank"
          rel="noreferrer"
        >
          contact our support team.
        </a>
      </Text>
    </>
  ),
  actions: ['cancel', 'logout'],
};

export default {
  defaultMessage,
  notMergedMessage,
  successMessage,
  confirmDifferentEmailsMessage,
  errorMessage,
};
